import { ISeanceReport } from 'src/types/seanceReport';
import CaseEnum from '../../enumerables/case-enum';
import { getValFromEnum } from '../../components/redux-form/utils/dropdown-values';

const caseEnum = CaseEnum ? CaseEnum.getEnum('caseType') : {};
export const groupSeanceReportToCsv = (data: ISeanceReport[]) => {
    const caseTypes: SelectObject[] = getValFromEnum(caseEnum);
    const groupData: any = [
        [
            'Case #',
            'Case Type',
            'Student',
            'Provider',
            'Supervisor',
            'Order ID',
            'Order',
            'Service',
            'Location',
            'Confirmed, hrs',
        ],
    ];
    data.forEach((it) => {
        let caseType: SelectObject | undefined | string = caseTypes.find((its) => its.value === it?.caseType);
        caseType = caseType ? caseType.label : '';
        groupData.push([
            it.caseNumber ? it.caseNumber : '',
            caseType,
            it.studentId ? it.studentFirstName + ' ' + it.studentLastName : '',
            it.providerId ? it.providerName : '',
            it.supervisor ? it.supervisor : '',
            it.orderId ?? '',
            it.orderName ?? '',
            it.serviceTypeTitle ?? '',
            it.serviceLocationTitle ?? '',
            it.confirmedHours ? it.confirmedHours : '',
        ]);
    });

    return groupData;
};
